/** Submit event for cf7 submission */
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if (!window.gtag) return;

    gtag("event", "wpcf7_submission", {
      event_category: event.detail.contactFormId,
      event_label: event.detail.unitTag,
    });
  },
  false,
);
